import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";
import axios from 'axios';
import './ActiveLocations.css';
import { baseURL } from './backend_url';
import { Modal, Button, Form } from 'react-bootstrap';
import fileDownload from 'js-file-download';
import Swal from 'sweetalert2';
import { MDBDataTable } from 'mdbreact';
import LinearProgress from '@mui/material/LinearProgress';

function UploadReservationData() {
  const fileInputRef = useRef(null);
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [savedData, setSavedData] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [file, setFile] = useState(null);
  const [columnData, setColumnData] = useState([]);
  const [rowsDetails, setRowsDetails] = useState([]);
  const [flagStatus, setFlagStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [access, setAccess] = useState("Edit");

  useEffect(() => {
    const companyIdTemp = '123456';
    setCompanyId(companyIdTemp);
    setSavedData([])
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    if ('Users' === foundUser.role) {
      setAccess(foundUser.access['UploadReservationData_Access Specifier']);
    }
    axios.get(baseURL + "/srt_get_external_location")
      .then((res) => {
        axios.get(baseURL + "/srt_get_external_active_location/" + companyIdTemp.toString())
          .then((res1) => {
            axios.get(baseURL + "/srt_get_user_location/" + foundUser.userEmail)
              .then((res2) => {
                const assigned_location_hash = res2.data;
                let allTemp = res.data.res;
                let hashLocationNameId = {};
                allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
                setHashLocationNameVsID(hashLocationNameId);
                if (allTemp.length > 0) {
                  let tempArr = [];
                  for (let i = 0; i < allTemp.length; i++) {
                    if (foundUser.role === 'Users') {
                      if (res1.data[allTemp[i].location_id] === true && assigned_location_hash[allTemp[i].location_id] === true) {
                        tempArr.push(allTemp[i]);
                      }
                    } else {
                      if (res1.data[allTemp[i].location_id] === true) {
                        tempArr.push(allTemp[i]);
                      }
                    }
                  }
                  setLocationDetail(tempArr);
                }
              })
          })
      });
  }, []);

  useEffect(() => {
    if (locationId) {
      setLoading(false);
      setRowsDetails([]);
      axios.get(baseURL + "/srt_get_uploaded_data/" + locationId.toString())
        .then((res) => {
          // setReservationDetail(res.data)
          let rowsData = [];
          const myDataSet = res.data;
          for (var index = 0; index < res.data.length; index++) {
            let rowItem = {};
            const val = myDataSet[index];
            rowItem["Reservation_Number"] = val.Reservation_Number
            rowItem["Pickup_Date_Time"] = val.Pickup_Date_Time.slice(0, -3)
            rowItem["DropOff_Date_Time"] = val.DropOff_Date_Time.slice(0, -3)
            rowItem["First_Name"] = val.First_Name
            rowItem["Last_Name"] = val.Last_Name
            rowItem["uploaded_date_time"] = val.uploaded_date_time.slice(0, -3)
            rowsData.push(rowItem)
          }
          setRowsDetails(rowsData);
          setColumnData([
            {
              label: "Reservation Number",
              field: "Reservation_Number",
              sort: "asc",
              width: 150,
            },
            {
              label: "Pickup Date Time",
              field: "Pickup_Date_Time",
              sort: "asc",
              width: 200,
            },
            {
              label: "DropOff Date Time",
              field: "DropOff_Date_Time",
              sort: "asc",
              width: 200,
            },
            {
              label: "First Name",
              field: "First_Name",
              sort: "asc",
              width: 200,
            },
            {
              label: "Last Name",
              field: "Last_Name",
              sort: "asc",
              width: 200,
            },
            {
              label: "Uploaded date time",
              field: "uploaded_date_time",
              sort: "asc",
              width: 200,
            },
          ]);


        })
    }

  }, [locationId, flagStatus])

  const data = {
    columns: columnData,
    rows: rowsDetails,
  };


  const companyNameOptions = companyDetail.map((value) => ({
    value: value.company_name, label: value.company_name
  }));

  const handleInputChangeCompanyName = (selectedOption) => {
    setCompanyName(selectedOption.value);
  };

  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsID[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId);
  };

  const downloadTemplate = () => {
    axios.get(baseURL + "/srt_download_template", { responseType: 'blob' })
      .then((res) => {
        fileDownload(res.data, 'Shuttle Tracking External res DB.xlsx');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileUpload = () => {
    if (locationName === '') {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please select location to proceed ahead',
      })
      return;
    }
    if (!file) {
      Swal.fire({
        position: 'middle',
        icon: 'error',
        title: 'Please choose excel file to proceed ahead',
      })
      return;
    }

    Swal.fire({
      title: 'Do you want to save this ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, proceed!',
      cancelButtonText: 'No, cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        axios.post(baseURL + "/srt_upload_data/" + locationId, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((res) => {
            if (res.data.status === 'success') {
              Swal.fire({
                position: 'middle',
                icon: 'success',
                title: 'Data Uploaded Successfully !!',
              })

            }
            else if (res.data.status === 'error') {
              Swal.fire({
                position: 'middle',
                icon: 'error',
                title: res.data.message,
                text: res.data.text
              })

            }

            setFlagStatus(!flagStatus);
            setLoading(false);
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
            setFile(null);

          })
          .catch((err) => {

            console.error(err);
            setLoading(false);
          });
      }
    })
  };

  return (
    <div className="container mt-5">
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Upload Reservation Data</h4>

        <>
          <div className="mb-4">
            <label htmlFor="location_name" className="form-label">
              Select Location
            </label>
            <Select
              value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
              inputId="location_name"
              name="location_name"
              options={locationDetail.map(location => ({
                value: location.location_id,
                label: `${location.location_name} - ${location.location_id.split('-').length > 2 ? location.location_id : location.location_id.split('-')[1]}`
              }))}
              onChange={handleInputChangeLocationName}
            />
          </div>

          <div className="mb-4">
            <Button onClick={downloadTemplate}>Download Excel Template</Button>
          </div>
          <div className="mb-4">
          Note: The template that will download contains 2 dummy rows prefilled for users' reference. Please delete the same before uploading.
          </div>
          {access === 'Edit' &&
            <div className="mb-4">
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Upload Excel File</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} ref={fileInputRef} />
              </Form.Group>
              <Button onClick={handleFileUpload}>Upload & Save</Button>
            </div>
          }
        </>
        {loading &&
          <>
            <div className='row  d-flext justify-content-center'>
              <div className='col-2'>Please Wait ...</div>
              <div className='col-12 '><LinearProgress /></div>
            </div>
          </>
        }

      </div>
      {rowsDetails.length > 0 &&
        <div className="row mt-3">
          <div className="col-md-12">
            <h5 className="mb-3">Existing Reservation(s): </h5>
            <MDBDataTable
              bordered
              large={false}
              data={data}
              sortable={false}
              responsiveLg={false}
              entries={"100"}
              noBottomColumns={!(rowsDetails.length > 7 && true)}
            />
          </div>
        </div>
      }
    </div>
  );
}

export default UploadReservationData;
